export const tippotH5 = {
  // 消息列表
  messages: "/api/msg/v1/messages",
};

/**语言包 */
export const LANGUAGE_PACK = {
  get_all_language:
    process.env.NODE_ENV !== "production"
      ? "https://yuliverse-beta.s3.ap-southeast-1.amazonaws.com/cfg/moonring_language_version_test.json"
      : "https://www.yuliverse.com/cfg/moonring_language_version.json",
};
